<p-dialog 
    [(visible)]="visible" 
    [style]="{ width: '600px' }"
    [modal]="true" 
    draggable="false" 
    resizable="false">
    <ng-template #headless>
        <div class="flex flex-col gap-4 m-2 p-4">
            <div class="flex flex-col gap-2" *ngIf="!isMeetingConvened">
                <div class="flex flex-col gap-4 items-start">
                    <div class="flex gap-4 items-start">
                        <p-check-box name="invitee" [(ngModel)]="inviteeType" [binary]="true" (ngModelChange)="resetInviteeSelected()" />
                        <label for="sigmapmember">{{ 'meeting.invitation.sigmap.label' | translate }}</label>
                    </div>
                    <div class="mt-4">
                        <sm-form-builder *ngIf="inviteeType" [formObject]="sigmapFieldFormObject"></sm-form-builder>
                    </div>
                </div>
            </div>
                    <sm-form-builder [formObject]="inviteeFormObject"></sm-form-builder>
        </div>
        
            <div class="flex justify-end gap-2 p-4">
                <p-button type="button" label="Annuler" icon="pi pi-times" class="p-button-text p-button-secondary" (click)="toggleVisible()"></p-button>
                <p-button type="button" label="Enregistrer" icon="pi pi-check" class="p-button-text p-button-primary" (click)="handleActionClick()"></p-button>
            </div>
       
    </ng-template>
</p-dialog>